import { ReferenceParentState } from './types';
import referenceParentParser from '@/shared/model/referenceParent';

export const state = (): ReferenceParentState => initialState();

export const initialState = (): ReferenceParentState => ({
  referenceParent: referenceParentParser.parse({}),
  referenceParents: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['refName'],
    },
  },
});
